import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {RuleFile} from './instruction-plugin-source'

// The web client renders sandbox-local image paths only from image bytes a tool already returned in the session.
const LOCAL_IMAGES_RULE: RuleFile = {
  name: 'github-web-local-images.mdc',
  content: `---
description: Showing image files in the GitHub web client
alwaysApply: true
---

To show the user an image file, reference its absolute path with \`![alt](/absolute/path.png)\`. If no earlier tool call in this session (such as a screenshot) already returned that image, call \`view\` on the path once first; never re-view an image just to show it.`,
}

/** Adds instruction rules the web client contributes to every relay that accepts instruction rules. */
export function withClientInstructionRules(rules: RuleFile[]): RuleFile[] {
  return isFeatureEnabled('copilot_mission_control_ahp_local_images') ? [...rules, LOCAL_IMAGES_RULE] : rules
}
